import './App.css';
import { Link } from "react-scroll";

// ============================================
// ASSETS — screenshots de proyectos (contenido real)
// ============================================
import mino from "./assets/projects/mino.png";
import minomx from "./assets/projects/minomx.png";
import minoapps from "./assets/projects/minoapps.png";
import maypa from "./assets/projects/maypa.png";
import sedena from "./assets/projects/sedena.png";
import rcc from "./assets/projects/rcc.png";
import fish from "./assets/projects/happyfish.png";
import catalogo from "./assets/projects/catalogo.png";
import astra from "./assets/projects/astra.png";

// ============================================
// DATA: navegación (el número refleja el orden real de lectura de la página)
// ============================================
const navLinks = [
  { to: "home", label: "Home", index: "01" },
  { to: "about", label: "About", index: "02" },
  { to: "projects", label: "Projects", index: "03" },
  { to: "contact", label: "Contact", index: "04" },
];

// ============================================
// DATA: tecnologías (chips tipográficos, sin depender de íconos externos)
// ============================================
const technologies = [
  "Java", "C++", "Visual Basic", "C#", "JavaScript", "PHP", "HTML5", "CSS3",
  "Android", "jQuery", "React", "React Native", "Ajax", "Next.js", "Node.js",
  "Express", "Bootstrap", "WordPress", "MongoDB", "SQL", "Tailwind", "Python",
];

// ============================================
// DATA: proyectos, ordenados cronológicamente (más reciente primero)
// ============================================
const projects = [
  { id: "mino-logistics", title: "Mino Logistics Web App", year: 2023, image: mino, stack: ["MongoDB", "Express", "React", "Node.js", "Tailwind", "Next.js"] },
  { id: "web-mino", title: "WEB MINO", year: 2022, image: minomx, stack: ["Next.js", "React", "Tailwind"] },
  { id: "mino-apps", title: "Mino Android/iOS Apps", year: 2022, image: minoapps, stack: ["React", "MongoDB"] },
  { id: "maypa", title: "MAYPA Payment Gateway", year: 2021, image: maypa, stack: ["HTML", "CSS", "JavaScript", "PHP", "MySQL"] },
  { id: "rcc", title: "RCC Construction Inc Web", year: 2021, image: rcc, stack: ["HTML", "CSS", "Bootstrap"] },
  { id: "sedena", title: "SEDENA App", year: 2021, image: sedena, stack: ["JavaScript", "React", "MySQL", "CSS", "Java", "Ajax"] },
  { id: "catalogo", title: "Catalogue Web App", year: 2020, image: catalogo, stack: ["HTML", "CSS", "JavaScript", "Bootstrap", "WordPress", "MySQL"] },
  { id: "flappy-bird", title: "Flappy Bird Video Game", year: 2019, image: fish, stack: ["C#"] },
  { id: "smartsale", title: "SmartSale", year: 2017, image: astra, stack: ["C#", "MySQL"] },
];

// ============================================
// DATA: redes sociales
// ============================================
const socialLinks = [
  { name: "GitHub", href: "https://github.com/luismz95", icon: "/github.svg", hoverBg: "group-hover:bg-black/60" },
  { name: "LinkedIn", href: "https://www.linkedin.com/in/luis-a-manzo-655130183/", icon: "/linkedin.svg", hoverBg: "group-hover:bg-blue-500/60" },
  { name: "Twitter", href: "https://twitter.com/luisangelmzo", icon: "/twitter.svg", hoverBg: "group-hover:bg-cyan-400/60" },
];

// ============================================
// COMPONENTE: Nav — unificado (antes eran Nav + Header duplicados)
// ============================================
const Nav = () => (
  <nav className="fixed top-0 w-full z-50 backdrop-blur-2xl backdrop-saturate-200 bg-[#10162B]/40 border-b border-white/10 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]">
    <div className="container mx-auto px-6 h-16 flex items-center justify-between">
      <Link
        to="home"
        smooth={true}
        className="font-mono text-sm text-[#F1F4FF] cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#4EB8F9] rounded"
      >
        {"<LM />"}
      </Link>

      <div className="flex items-center gap-1 sm:gap-2">
        {navLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            smooth={true}
            spy={true}
            activeClass="active"
            className="group cursor-pointer px-2 sm:px-3 py-2 rounded-md flex items-center gap-1.5 text-[#8993B8] hover:text-[#F1F4FF] transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#4EB8F9]"
          >
            <span className="font-mono text-[10px] text-[#4EB8F9]/70 group-hover:text-[#4EB8F9]">
              {link.index}
            </span>
            <span className="text-sm hidden sm:inline">{link.label}</span>
          </Link>
        ))}
      </div>
    </div>
  </nav>
);

// ============================================
// COMPONENTE: HeroPanel — el elemento "firma" del diseño
// ============================================
const HeroPanel = () => (
  <div className="w-full max-w-md rounded-xl border border-[#202844] bg-[#10162B] shadow-2xl shadow-black/50 overflow-hidden">
    <div className="flex items-center gap-2 px-4 py-3 border-b border-[#202844] bg-[#0D1224]">
      <span className="w-3 h-3 rounded-full bg-[#F43F5E]/70" />
      <span className="w-3 h-3 rounded-full bg-[#B848EC]/70" />
      <span className="w-3 h-3 rounded-full bg-[#4EB8F9]/70" />
      <span className="ml-3 font-mono text-xs text-[#8993B8]">profile.json</span>
    </div>
    <pre className="font-mono text-[13px] sm:text-sm leading-7 p-5 text-[#F1F4FF] overflow-x-auto">
<span className="text-[#8993B8]">{"{"}</span>{"\n"}
{"  "}<span className="text-[#4EB8F9]">"name"</span>: <span className="text-[#F43F5E]">"Luis Angel Manzo"</span>,{"\n"}
{"  "}<span className="text-[#4EB8F9]">"role"</span>: <span className="text-[#F43F5E]">"Backend &amp; Frontend Developer"</span>,{"\n"}
{"  "}<span className="text-[#4EB8F9]">"experience"</span>: <span className="text-[#F43F5E]">"6+ years"</span>,{"\n"}
{"  "}<span className="text-[#4EB8F9]">"currently"</span>: <span className="text-[#F43F5E]">"learning something new"</span><span className="cursor-blink text-[#8993B8]">_</span>{"\n"}
<span className="text-[#8993B8]">{"}"}</span>
    </pre>
  </div>
);

// ============================================
// COMPONENTE: Banner (sección "home")
// ============================================
const Banner = () => (
  <div className="section" id="home">
    <div className="container mx-auto px-6">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        <div className="flex-1 text-center lg:text-left">
          <p className="font-mono text-sm text-[#4EB8F9] mb-4">{"// full-stack developer"}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <span className="text-[#F1F4FF]">Hi, I'm </span>
            <span className="gradient-text">Luis Angel</span>
          </h1>
          <p className="text-[#8993B8] text-base lg:text-lg max-w-lg mx-auto lg:mx-0 mb-8">
            <strong className="text-[#F1F4FF] font-medium">Backend</strong> and{" "}
            <strong className="text-[#F1F4FF] font-medium">Frontend</strong> developer with more than 6 years of
            experience, passionate about learning new technologies to continue growing.
          </p>
          <div className="flex items-center justify-center lg:justify-start gap-4">
            <Link
              to="projects"
              smooth={true}
              className="cursor-pointer font-mono text-sm border border-[#202844] hover:border-[#4EB8F9] text-[#F1F4FF] px-5 py-3 rounded-lg transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#4EB8F9]"
            >
              View Projects
            </Link>
            <Link
              to="contact"
              smooth={true}
              className="btn cursor-pointer font-mono text-sm text-white px-5 py-3 rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              Get in Touch
            </Link>
          </div>
        </div>

        <div className="flex-1 flex justify-center w-full">
          <HeroPanel />
        </div>
      </div>
    </div>
  </div>
);

// ============================================
// COMPONENTE: About (sección "about")
// ============================================
const stats = [
  { value: `${projects.length}`, label: "projects shipped" },
  { value: `${technologies.length}`, label: "technologies used" },
  { value: "6+", label: "years experience" },
];

const About = () => (
  <div className="section" id="about">
    <div className="container mx-auto px-6">
      <div className="max-w-3xl mx-auto text-center">
        <p className="font-mono text-sm text-[#4EB8F9] mb-3">{"// about"}</p>
        <h2 className="text-3xl lg:text-4xl font-bold text-[#F1F4FF] mb-8" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Luis Angel Manzo
        </h2>

        <p className="text-[#8993B8] leading-relaxed mb-12">
          I entered the world of programming during my high school years, driven by a persistent curiosity about
          how things work. This curiosity has been with me since childhood, and through programming, I've been able
          to turn my wonder into tangible accomplishments. It's incredible to witness how the future is rapidly
          approaching in ways we once only imagined, and this transformation is made possible by the relentless
          progression of technology.
        </p>

        <div className="grid grid-cols-3 gap-6 border-t border-[#202844] pt-8">
          {stats.map((stat) => (
            <div key={stat.label}>
              <p className="gradient-text text-3xl lg:text-4xl font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                {stat.value}
              </p>
              <p className="font-mono text-[11px] sm:text-xs text-[#8993B8] mt-1 uppercase tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

// ============================================
// COMPONENTE: TechChip — reemplaza los íconos rotos por tipografía
// ============================================


const techNeon = {
  "HTML": "#FF6B35",
  "HTML5": "#FF6B35",
  "CSS": "#2965F1",
  "CSS3": "#2965F1",
  "JavaScript": "#F7DF1E",
  "Node.js": "#39FF14",
  "React": "#61DAFB",
  "React Native": "#61DAFB",
  "Next.js": "#FFFFFF",
  "Express": "#B0B3B8",
  "MongoDB": "#39D67A",
  "MySQL": "#00A9E6",
  "SQL": "#00A9E6",
  "PHP": "#8892FF",
  "Java": "#F58231",
  "C++": "#00A3E0",
  "C#": "#B84EF5",
  "Visual Basic": "#5F9EA0",
  "Python": "#FFD43B",
  "Tailwind": "#38BDF8",
  "Bootstrap": "#C158FF",
  "WordPress": "#4AA8E0",
  "Android": "#39FF14",
  "jQuery": "#4EB8F9",
  "Ajax": "#F43F5E",
};


const TechChip = ({ label, tone = "muted" }) => (
  <span
    style={{ "--neon": techNeon[label] || "#4EB8F9" }}
    className={`tech-chip font-mono text-xs px-2.5 py-1 rounded-md border cursor-default ${
      tone === "muted"
        ? "border-[#202844] text-[#8993B8]"
        : "border-[#4EB8F9]/40 text-[#4EB8F9] bg-[#4EB8F9]/5"
    }`}
  >
    {label}
  </span>
);

// ============================================
// COMPONENTE: ProjectEntry — una fila del timeline
// ============================================
const ProjectEntry = ({ project }) => (
  <div className="timeline-item">
    <div className="flex flex-col md:flex-row gap-6 md:items-center">
      <img
        src={project.image}
        alt={project.title}
        className="w-full md:w-64 h-40 object-cover rounded-lg border border-[#202844]"
      />
      <div className="flex-1">
        <p className="font-mono text-xs text-[#4EB8F9] mb-1">{project.year}</p>
        <h3 className="text-lg font-semibold text-[#F1F4FF] mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {project.title}
        </h3>
        <div className="flex flex-wrap gap-2">
          {project.stack.map((tech) => (
            <TechChip key={tech} label={tech} tone="accent" />
          ))}
        </div>
      </div>
    </div>
  </div>
);

// ============================================
// COMPONENTE: Projects (sección "projects")
// ============================================
const Projects = () => (
  <div className="section" id="projects">
    <div className="container mx-auto px-6">
      <p className="font-mono text-sm text-[#4EB8F9] mb-3 text-center">{"// projects"}</p>
      <h2 className="text-3xl lg:text-4xl font-bold text-[#F1F4FF] mb-16 text-center" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
        Project history
      </h2>

      <div className="timeline max-w-3xl mx-auto flex flex-col gap-12">
        {projects.map((project) => (
          <ProjectEntry key={project.id} project={project} />
        ))}
      </div>

      <div className="max-w-4xl mx-auto mt-20 pt-10 border-t border-[#202844]">
        <p className="font-mono text-xs text-[#8993B8] mb-4 uppercase tracking-wide text-center">
          Technologies I work with
        </p>
        <div className="flex flex-wrap justify-center gap-2">
          {technologies.map((tech) => (
            <TechChip key={tech} label={tech} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

// ============================================
// COMPONENTE: SocialButton
// ============================================
const SocialButton = ({ social }) => (
  <a
    href={social.href}
    target="_blank"
    rel="noopener noreferrer"
    className="group relative w-14 h-14 flex items-center justify-center border border-[#202844] rounded-xl overflow-hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#4EB8F9]"
    aria-label={social.name}
  >
    <div className={`absolute inset-0 ${social.hoverBg} opacity-0 group-hover:opacity-100 transition-opacity duration-200`} />
    <img
      src={social.icon}
      alt=""
      width={22}
      className="relative invert group-hover:scale-110 transition-transform duration-200"
    />
  </a>
);

// ============================================
// COMPONENTE: Contact (sección "contact")
// ============================================
const Contact = () => (
  <div className="section" id="contact">
    <div className="container mx-auto px-6">
      <div className="max-w-md mx-auto text-center">
        <p className="font-mono text-sm text-[#4EB8F9] mb-3">{"//contact"} </p>
        <h2 className="text-3xl lg:text-4xl font-bold text-[#F1F4FF] mb-10" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          Let's work together
        </h2>

        <div className="rounded-xl border border-[#202844] bg-[#10162B] divide-y divide-[#202844] mb-10 text-left overflow-hidden">
          <a href="tel:+526642347380" className="flex items-center justify-between px-5 py-4 hover:bg-[#161D38] transition-colors">
            <span className="font-mono text-xs text-[#8993B8]">phone</span>
            <span className="text-sm text-[#F1F4FF]">+52 664 234 7380</span>
          </a>
          <a href="mailto:lmanzo@uabc.edu.mx" className="flex items-center justify-between px-5 py-4 hover:bg-[#161D38] transition-colors">
            <span className="font-mono text-xs text-[#8993B8]">email</span>
            <span className="text-sm text-[#F1F4FF]">lmanzo@uabc.edu.mx</span>
          </a>
        </div>

        <div className="flex justify-center gap-4">
          {socialLinks.map((social) => (
            <SocialButton key={social.name} social={social} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

// ============================================
// APP (composición final)
// ============================================
const App = () => {
  return (
    <div className="bg-[#0A0E1A] min-h-screen">
      <Nav />
      <Banner />
      <About />
      <Projects />
      <Contact />
    </div>
  );
};

export default App;
